import { EntityDetail } from "@/components/finance/EntityDetail";
import { LOAN_FIELDS, LOAN_MOVES, money } from "@/lib/finance";

const Summary = ({ item }) => {
  const s = item.stats;
  const c = item.currency;
  return (
    <div data-testid="loan-summary" className="rounded-2xl p-4 bg-[#0b2a47] text-white space-y-3">
      <div>
        <p className="text-[11px] opacity-70">Saldo pendiente</p>
        <p data-testid="summary-outstanding" className="font-mono text-2xl font-bold tabular-nums">{money(s.outstanding, c)}</p>
      </div>
      <div className="grid grid-cols-3 gap-2 text-xs">
        <div><p className="opacity-70">Capital</p><p className="font-mono font-semibold">{money(s.principal, c)}</p></div>
        <div><p className="opacity-70">Capital pagado</p><p data-testid="summary-capital-paid" className="font-mono font-semibold">{money(s.capital_paid, c)}</p></div>
        <div><p className="opacity-70">Intereses</p><p data-testid="summary-interest-paid" className="font-mono font-semibold">{money(s.interest_paid, c)}</p></div>
      </div>
    </div>
  );
};

export default function LoanDetailPage() {
  return <EntityDetail endpoint="/loans" backTo="/inversiones?tab=prestamos" eyebrow="Préstamo" titleKey="borrower_name" fields={LOAN_FIELDS} moveTypes={LOAN_MOVES} Summary={Summary} />;
}
